import React from 'react';
import { css } from '@emotion/core';
import { mq } from '@helpers/breakpoints';
import styled from '@emotion/styled';

import Colors from '@theme/colors';

const FormInput = (props: any) => (
  <div
    css={mq({
      display: 'flex',
      width: '100%',
      borderRadius: '4px',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: Colors.grayLight9,
      '&:hover': {
        borderColor: `${Colors.science37}`,
      },
      '&:focus-within': {
        outline: 'none !important',
        borderColor: `${Colors.science37} !important`,
      },
      ...props.containerStyle,
    })}
  >
    {props.type === 'textArea' ? (
      <textarea
        {...props}
        css={props.inputStyle}
        datai={props.dataI}
        style={{ resize: 'none', height: 'auto' }}
        rows="4"
      />
    ) : (
      <input {...props} css={props.inputStyle} datai={props.dataI} />
    )}
    {props.icon && props.icon}
  </div>
);

const FormInputStyle = ({}) => css`
  box-shadow: none !important;
  height: 36px;
  border-radius: 4px;
  ${mq({
    fontSize: '16px',
    fontFamily: 'Lato',
    width: '100%',
    padding: '0 10px',
    borderColor: 'transparent',
    color: `${Colors.neutral75}`,
    wordSpacing: '4px',
  })};
  &:placeholder {
    color: #7a8790;
  }
`;

const FormInputStyled = styled(FormInput)`
  ${FormInputStyle}
`;

export default FormInputStyled;
